import React from 'react';
import { IonImg } from '@ionic/react';

// Helpers
import { formatNumber } from '../../helpers';

// Styles
import './TransactionSuccessOverlay.css';

/**
 * Renderiza la imagen de éxito con un overlay superpuesto que muestra
 * el resumen de la transacción confirmada.
 *
 * - Beneficio porcentual (hasCalculableDiscount=true): muestra beneficio, importe original,
 *   descuento ahorrado e importe final con descuento.
 * - Beneficio no porcentual (hasCalculableDiscount=false, ej. "2x1"): muestra beneficio y
 *   total (importe bruto, sin resta de descuento).
 * - Sin beneficio: no renderiza el overlay.
 *
 * @param {string}  benefitType            - Tipo de beneficio (ej: "20%", "2x1")
 * @param {string}  benefitTitle           - Título del beneficio
 * @param {number}  amount                 - Importe original sin descuento
 * @param {number}  discountAmount         - Importe final con descuento aplicado
 * @param {boolean} hasCalculableDiscount  - true si el tipo de beneficio es porcentual
 */
export const TransactionSuccessOverlay = ({ benefitType, benefitTitle, amount, discountAmount, hasCalculableDiscount }) => {

    // El overlay se muestra siempre que haya un beneficio válido
    const hasBenefit = benefitType && benefitTitle;
    const showOverlay = hasBenefit;

    // Descuento ahorrado: solo relevante para tipos porcentuales
    const saved = hasCalculableDiscount && showOverlay
        ? parseFloat((amount - discountAmount).toFixed(2))
        : 0;

    return (
        <div className="success-overlay-wrapper">
            <IonImg
                className="msg__img"
                src="assets/images/success.png"
            />

            {showOverlay && (
                <div className={`success-overlay${!hasCalculableDiscount ? ' success-overlay--compact' : ''}`}>
                    {/* Fila del beneficio: título prominente, sin label redundante */}
                    <div className="success-overlay__benefit-title">
                        {`${benefitType} ${benefitTitle}`}
                    </div>
                    <div className="success-overlay__divider" />

                    {hasCalculableDiscount ? (
                        <>
                            {/* Layout porcentual: importe original + descuento + total */}
                            <div className="success-overlay__row">
                                <span className="success-overlay__label">Importe original</span>
                                <span className="success-overlay__value">${formatNumber(amount)}</span>
                            </div>
                            <div className="success-overlay__divider" />
                            <div className="success-overlay__row">
                                <span className="success-overlay__label">Descuento</span>
                                <span className="success-overlay__value success-overlay__discount">- ${formatNumber(saved)}</span>
                            </div>
                            <div className="success-overlay__divider" />
                            <div className="success-overlay__row">
                                <span className="success-overlay__label">Total</span>
                                <span className="success-overlay__value">${formatNumber(discountAmount)}</span>
                            </div>
                        </>
                    ) : (
                        <>
                            {/* Layout no porcentual (ej. 2x1): solo total (importe bruto) */}
                            <div className="success-overlay__row">
                                <span className="success-overlay__label">Total</span>
                                <span className="success-overlay__value">${formatNumber(amount)}</span>
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default TransactionSuccessOverlay;
